import React from 'react'
import Navbar from '../components/navbar/navbar'

const FreeAd = () => {
    return (
        <>
            <Navbar transparent={false} />
            <section>
                <div className="container">
                    <p className='content-i'>
                        Ready to boost your property listings completely risk-free? Follow this
                        simple step-by-step guide to unlock <b>45 days of FREE advertising—</b>no
                        credit card needed! Take advantage of this limited-time promo code and
                        start attracting buyers and tenants today!
                    </p>
                    <h3><span className="font-normal">
                        Step #1</span></h3>
                    <img src={require('../assets/img/step1.png')} height={"auto"} />
                    <h3 className='mt-5'><span className="font-normal">
                        Step #2</span></h3>
                    <img src={require('../assets/img/step2.png')} height={"auto"} />
                    <h3 className='mt-5'><span className="font-normal">
                        Step #3</span></h3>
                    <img src={require('../assets/img/step3.png')} height={"auto"} />
                    <h3 className='mt-5'><span className="font-normal">
                        Step #4</span></h3>
                    <img src={require('../assets/img/step4.png')} height={"auto"} />
                    <h3 className='mt-5'><span className="font-normal">
                        Step #5</span></h3>
                    <img src={require('../assets/img/step5.jpg')} height={"auto"} />
                    <h3 className='mt-5'><span className="font-normal">
                        Step #6</span></h3>
                    <img src={require('../assets/img/step6.png')} height={"auto"} />
                </div>
            </section>
        </>
    )
}

export default FreeAd